import type {z} from 'zod'
import {TimeEntry} from '../timeEntry/TimeEntry.js'
import {RecommendationSource} from './RecommendationSource.js'
import {RecommendationId} from './RecommendationId.js'

export const Recommendation = TimeEntry.omit({
  id: true,
  source: true,
}).extend({
  id: RecommendationId,
  source: RecommendationSource,
})

export type Recommendation = z.infer<typeof Recommendation>
